import React, { useEffect, useState, useCallback, useRef } from "react";
import { useSelector } from "react-redux";
import InnerTitle from "../components/InnerTitle";
import Card from "../components/Card";
import SellerCard from "../components/SellerCard";
import { globalsearchData, favouriteUnfavouriteStream, getProductCategories, getProductSubCategories, getProductPreSubCategories, getProductAttributes, getPreSubCategoryDetails, getColorPalettes } from "../services/stream.service";
import { favouriteUnfavouriteProduct } from "../services/product.services";
import ShoplistSelectModal from "../components/ShoplistSelectModal";
import CategorySelectDropdown from "../components/CategorySelectDropdown";
import { X, SlidersHorizontal, Trash2 } from "lucide-react";
import { capitalizeFirstLetter, getSellerProfileUrl } from "../../../utils/commonfunction";
import { PALETTE_COLUMNS, getColorTabName } from "../../admin/common/colorPalettePicker";


import { useNavigate, useSearchParams } from "react-router-dom";
import Swal from "sweetalert2";
import { getUser, isGuest, isUserLoggedIn, showLoginRequiredModal } from "../../../utils/commonfunction";
import { ROLE } from "../../../utils/Constants";
import { useTranslation } from "react-i18next";
const TABS = [
  { key: "streams", label: "search.tabs.streams" },
  { key: "products", label: "search.tabs.products" },
  { key: "sellers", label: "search.tabs.sellers" },
];

const PER_PAGE = 20;

const METALLIC_COLORS_GRADIENT = [
  { name: "Metallic Gold", gradient: "linear-gradient(135deg, #bf953f 0%, #fcf6ba 25%, #b38728 50%, #fbf5b7 75%, #aa771c 100%)" },
  { name: "Metallic Silver", gradient: "linear-gradient(135deg, #9c9c9c 0%, #f1f1f1 50%, #c0c0c0 100%)" },
  { name: "Rose Gold", gradient: "linear-gradient(135deg, #b76e79 0%, #f3d1d6 50%, #9e505c 100%)" },
  { name: "Bronze", gradient: "linear-gradient(135deg, #8f5d38 0%, #dfbfa1 50%, #a87c53 100%)" },
  { name: "Copper", gradient: "linear-gradient(135deg, #8a4f1c 0%, #f0c2a2 50%, #b87333 100%)" },
  { name: "Champagne", gradient: "linear-gradient(135deg, #e3ceab 0%, #fff6e6 50%, #f7e7ce 100%)" }
];

const getColorPalateName = (name, hex) => {
  return getColorTabName(name, hex);
};

// Dynamic color palette helpers are now inside Search component

const getPalateBackground = (colors, palateName) => {
  if (!colors || colors.length === 0) return '#ccc';

  if (colors.length === 1) {
    const v = colors[0].name || "";
    const colorCode = colors[0].hex || colors[0].colorCode || "#ccc";
    const isTransparent = v.toLowerCase() === 'transparent' || colorCode === 'transparent';
    const isMulticolour = v.toLowerCase() === 'multicolour' || v.toLowerCase() === 'multicolor';
    const isMetallic = palateName.toLowerCase().includes('metallic');
    if (isTransparent) return 'repeating-conic-gradient(#ccc 0% 25%, white 0% 50%) 50% / 100% 100%';
    if (isMulticolour) return 'linear-gradient(135deg, #ff0000, #ff7f00, #ffff00, #00ff00, #0000ff, #4b0082, #8f00ff)';
    if (isMetallic) {
      const metallic = METALLIC_COLORS_GRADIENT.find(m => m.name.toLowerCase() === v.toLowerCase()) || { gradient: colorCode };
      return metallic.gradient;
    }
    return colorCode;
  }

  const segmentAngle = 360 / colors.length;
  const gradientParts = colors.map((item, idx) => {
    const start = idx * segmentAngle;
    const end = (idx + 1) * segmentAngle;
    let colorVal = item.hex || item.colorCode || '#ccc';
    const itemName = item.name || "";
    if (itemName.toLowerCase() === 'transparent' || colorVal === 'transparent') {
      colorVal = '#ffffff';
    } else if (itemName.toLowerCase() === 'multicolour' || itemName.toLowerCase() === 'multicolor') {
      colorVal = '#ff00ff';
    }
    return `${colorVal} ${start}deg ${end}deg`;
  });
  return `conic-gradient(${gradientParts.join(', ')})`;
};

function Search() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const query = searchParams.get("query") || "";
  const [activeTab, setActiveTab] = useState("products");
  const [page, setPage] = useState(1);
  const [searchInput, setSearchInput] = useState(query);
  const [debouncedQuery, setDebouncedQuery] = useState(query);
  const navigate = useNavigate();
  const reduxUserData = useSelector((state) => state.profile.profileData);

  const [data, setData] = useState({ streams: [], products: [], sellers: [] });
  const [totalCounts, setTotalCounts] = useState({ streams: 0, products: 0, sellers: 0 });
  const [loading, setLoading] = useState(false);
  const [nearbyLocation, setNearbyLocation] = useState(null);

  const [globalData, setGlobalData] = useState({});
  const myGlobalData = useSelector((state) => state.globalData);
  useEffect(() => {
    if (myGlobalData && myGlobalData?.data) {
      const settingsData = JSON.parse(myGlobalData?.data);
      setGlobalData(settingsData);
    }
  }, [myGlobalData]);

  // Filters State
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [preSubCategories, setPreSubCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedSubCategory, setSelectedSubCategory] = useState("");
  const [selectedPreSubCategory, setSelectedPreSubCategory] = useState("");
  const [searchAttributes, setSearchAttributes] = useState([]);
  const [selectedAttributes, setSelectedAttributes] = useState({});
  const [attributeFacets, setAttributeFacets] = useState({});
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [modalProduct, setModalProduct] = useState(null);
  const [isShoplistModalOpen, setIsShoplistModalOpen] = useState(false);
  const [attributeSearch, setAttributeSearch] = useState("");
  const [expandedPalate, setExpandedPalate] = useState({});
  const [hoveredPalate, setHoveredPalate] = useState(null);
  const observer = useRef();

  const [colorPalettes, setColorPalettes] = useState([]);
  const [colorKeys, setColorKeys] = useState(["COLOR REAL", "Color", "Colors"]);
  const [isColorPaletteBoxOpen, setIsColorPaletteBoxOpen] = useState(false);
  const [selectedPaletteIdForColors, setSelectedPaletteIdForColors] = useState(null);

  useEffect(() => {
    // Fetch dynamic color palettes
    getColorPalettes().then(resp => {
      if (resp?.success && Array.isArray(resp.data)) {
        setColorPalettes(resp.data);
      }
    });

    // Fetch all attributes to detect color keys
    getProductAttributes().then(resp => {
      if (resp?.success && Array.isArray(resp.data)) {
        const keys = resp.data
          .filter(attr => attr.hasColorCode || attr.name.toLowerCase().includes("color") || attr.name.toLowerCase().includes("colour"))
          .map(attr => attr.name);
        if (keys.length > 0) {
          setColorKeys(keys);
        }
      }
    });
  }, []);

  const expandTabValues = (values) => {
    const expanded = [];
    (values || []).forEach(val => {
      if (val && typeof val === 'object' && val.colorCode && val.colorCode.startsWith("tab:")) {
        const tabName = val.colorCode.replace("tab:", "");
        const col = colorPalettes.find(c => c.name === tabName);
        if (col && col.colors) {
          col.colors.forEach(c => {
            expanded.push({
              name: c.name,
              colorCode: c.hex
            });
          });
        }
      } else {
        expanded.push(val);
      }
    });
    return expanded;
  };

  const getTabColors = (tabName) => {
    const col = colorPalettes.find(c => c.name === tabName);
    if (col && col.colors) {
      return col.colors.map(c => ({ name: c.name, colorCode: c.hex }));
    }
    return [];
  };

  const activeSelectedColors = [];
  const allDetectedColorKeys = new Set([...colorKeys, "COLOR REAL", "Color", "Colors", "Colours"]);
  Object.keys(selectedAttributes).forEach(key => {
    const isColor = allDetectedColorKeys.has(key) || key.toLowerCase().includes("color") || key.toLowerCase().includes("colour") || key.toLowerCase().includes("palate") || key.toLowerCase().includes("palette");
    if (isColor && Array.isArray(selectedAttributes[key])) {
      selectedAttributes[key].forEach(c => {
        if (c && !activeSelectedColors.includes(c)) {
          activeSelectedColors.push(c);
        }
      });
    } else if (isColor && typeof selectedAttributes[key] === "string" && selectedAttributes[key]) {
      if (!activeSelectedColors.includes(selectedAttributes[key])) {
        activeSelectedColors.push(selectedAttributes[key]);
      }
    }
  });

  const getMatchingProductImage = (item, selectedColors) => {
    if (!item) return null;
    const images = item.images;
    if (!Array.isArray(images) || images.length === 0 || !Array.isArray(selectedColors) || selectedColors.length === 0) {
      return null;
    }

    const normalizedSelected = selectedColors
      .map(c => String(c || "").trim().toLowerCase())
      .filter(Boolean);

    if (normalizedSelected.length === 0) return null;

    // 1. Exact match (case-insensitive) on img.color
    for (const sel of normalizedSelected) {
      const match = images.find(img => {
        if (!img) return false;
        const imgColor = typeof img.color === "string"
          ? img.color.trim().toLowerCase()
          : (img.color?.name ? String(img.color.name).trim().toLowerCase() : "");
        return imgColor && imgColor === sel;
      });
      if (match) return match;
    }

    // 2. Substring match (e.g. "Royal Blue" matching "Blue", or vice versa)
    for (const sel of normalizedSelected) {
      const match = images.find(img => {
        if (!img) return false;
        const imgColor = typeof img.color === "string"
          ? img.color.trim().toLowerCase()
          : (img.color?.name ? String(img.color.name).trim().toLowerCase() : "");
        return imgColor && (imgColor.includes(sel) || sel.includes(imgColor));
      });
      if (match) return match;
    }

    return null;
  };

  const toggleSubColor = (colorName) => {
    setSelectedAttributes(prev => {
      const newState = { ...prev };
      let nextColors;
      if (activeSelectedColors.includes(colorName)) {
        nextColors = activeSelectedColors.filter(c => c !== colorName);
      } else {
        nextColors = [...activeSelectedColors, colorName];
      }

      colorKeys.forEach(key => {
        if (nextColors.length === 0) {
          delete newState[key];
        } else {
          newState[key] = nextColors;
        }
      });
      return newState;
    });
  };

  const toggleAllColorsInTab = (tabColors, selectAll) => {
    const tabColorNames = tabColors.map(c => c.name);
    setSelectedAttributes(prev => {
      const newState = { ...prev };
      let nextColors;
      if (selectAll) {
        nextColors = [...new Set([...activeSelectedColors, ...tabColorNames])];
      } else {
        nextColors = activeSelectedColors.filter(c => !tabColorNames.includes(c));
      }

      colorKeys.forEach(key => {
        if (nextColors.length === 0) {
          delete newState[key];
        } else {
          newState[key] = nextColors;
        }
      });
      return newState;
    });
  };

  const clearColorFilter = () => {
    setSelectedAttributes(prev => {
      const newState = { ...prev };
      colorKeys.forEach(key => {
        delete newState[key];
      });
      return newState;
    });
    setSelectedPaletteIdForColors(null);
  };

  const getSelectedFiltersCount = () => {
    let count = 0;
    Object.keys(selectedAttributes).forEach((attrName) => {
      const selectedValues = selectedAttributes[attrName] || [];
      const attr = searchAttributes.find((a) => a.name === attrName);
      const isColor =
        attrName.toLowerCase().includes("color") ||
        attrName.toLowerCase().includes("colour") ||
        attrName.toLowerCase().includes("palate") ||
        attrName.toLowerCase().includes("palette") ||
        (attr && attr.hasColorCode);

      if (isColor) {
        colorPalettes.forEach((col) => {
          const tabColorNames = col.colors ? col.colors.map((c) => c.name) : [];
          const hasSelectedColor = selectedValues.some((val) =>
            tabColorNames.includes(val)
          );
          if (hasSelectedColor) {
            count++;
          }
        });
        const allTabColorNames = colorPalettes.reduce(
          (acc, col) => acc.concat(col.colors ? col.colors.map((c) => c.name) : []),
          []
        );
        const unmatchedCount = selectedValues.filter(
          (val) => !allTabColorNames.includes(val)
        ).length;
        count += unmatchedCount;
      } else {
        count += selectedValues.length;
      }
    });
    return count;
  };

  const handleLikeFavourite = async (item) => {
    const user = getUser(ROLE.USER);
    const isLoggedIn = Boolean(
      user && 
      (user._id || user.id || user.token) && 
      !isGuest()
    );

    if (!isLoggedIn) {
      Swal.fire({
        icon: "warning",
        title: t("common.login_required"),
        text: t("common.login_required_to_favorite", { defaultValue: "Please login to add to favourites" }),
        showCancelButton: true,
        confirmButtonColor: "var(--primary-400, #ff4081)",
        cancelButtonColor: "#71717a",
        confirmButtonText: t("link_login", { defaultValue: "Login" }),
        cancelButtonText: t("product_details.close", { defaultValue: "Close" }),
      }).then((result) => {
        if (result.isConfirmed) {
          const currentPath = window.location.pathname + window.location.search;
          navigate(`/user/login?redirect=${encodeURIComponent(currentPath)}`);
        }
      });
      return;
    }
    try {
      const resp = await favouriteUnfavouriteStream(item._id);
      if (resp.success) {
        Swal.fire({
          icon: 'success',
          text: resp.message,
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        });

        setData(prev => ({
          ...prev,
          streams: prev.streams.map(s => s._id === item._id ? { ...s, isFavouriteStream: !s.isFavouriteStream } : s)
        }));
      }
    } catch (error) {
      console.error("Failed to toggle favourite:", error);
    }
  };

  const handleLikeFavouriteProduct = async (item) => {
    const user = getUser(ROLE.USER);
    const isLoggedIn = Boolean(
      user && 
      (user._id || user.id || user.token) && 
      !isGuest()
    );

    if (!isLoggedIn) {
      Swal.fire({
        icon: "warning",
        title: t("common.login_required"),
        text: t("common.login_required_to_favorite", { defaultValue: "Please login to add to favourites" }),
        showCancelButton: true,
        confirmButtonColor: "var(--primary-400, #ff4081)",
        cancelButtonColor: "#71717a",
        confirmButtonText: t("link_login", { defaultValue: "Login" }),
        cancelButtonText: t("product_details.close", { defaultValue: "Close" }),
      }).then((result) => {
        if (result.isConfirmed) {
          const currentPath = window.location.pathname + window.location.search;
          navigate(`/user/login?redirect=${encodeURIComponent(currentPath)}`);
        }
      });
      return;
    }

    setModalProduct(item);
    setIsShoplistModalOpen(true);
  };

  const handleShoplistSaved = (savedShoplistIds) => {
    if (modalProduct) {
      const isFav = Array.isArray(savedShoplistIds) && savedShoplistIds.length > 0;
      setData((prev) => ({
        ...prev,
        products: prev.products.map((p) =>
          p._id === modalProduct._id
            ? { ...p, isFavourite: isFav, isFavouriteProduct: isFav }
            : p
        ),
      }));
    }
  };

  const fetchCategories = async () => {
    try {
      const resp = await getProductCategories();
      if (resp?.success) {
        setCategories(resp.data?.list || []);
      }
    } catch (error) {
      console.error("Failed to fetch categories:", error);
    }
  };

  const fetchSubCategories = async (catId) => {
    if (!catId) {
      setSubCategories([]);
      return;
    }
    try {
      const resp = await getProductSubCategories(catId);
      if (resp?.success) {
        setSubCategories(resp.data?.list || []);
      }
    } catch (error) {
      console.error("Failed to fetch subcategories:", error);
    }
  };

  const fetchPreSubCategories = async (subId) => {
    if (!subId) {
      setPreSubCategories([]);
      return;
    }
    try {
      const resp = await getProductPreSubCategories(subId);
      if (resp?.success) {
        setPreSubCategories(resp.data?.list || []);
      }
    } catch (error) {
      console.error("Failed to fetch presubcategories:", error);
    }
  };

  const fetchAttributes = async (catId, preSubId = null) => {
    try {
      if (preSubId) {
        const resp = await getPreSubCategoryDetails(preSubId);
        if (resp?.success && resp.data?.attributes) {
          setSearchAttributes(resp.data.attributes);
          return;
        }
      }

      if (catId) {
        const resp = await getProductAttributes(catId);
        if (resp?.success) {
          setSearchAttributes(resp.data || []);
        }
      } else {
        setSearchAttributes([]);
      }
    } catch (error) {
      console.error("Failed to fetch attributes:", error);
    }
  };


  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchData = useCallback(async (tab = activeTab, pg = page) => {
    try {
      setLoading(true);
      const payload = {
        search: debouncedQuery || "",
        page: pg,
        per_page: PER_PAGE,
        type: tab,
        latitude: nearbyLocation ? nearbyLocation.latitude : undefined,
        longitude: nearbyLocation ? nearbyLocation.longitude : undefined,
        categoryId: selectedCategory || undefined,
        subcategoryId: selectedSubCategory || undefined,
        preSubCategoryId: selectedPreSubCategory || undefined,
        attributes: Object.keys(selectedAttributes).length > 0
          ? selectedAttributes
          : undefined
      };

      const [resp] = await Promise.all([
        globalsearchData(payload),
        new Promise((resolve) => setTimeout(resolve, 500)),
      ]);

      if (resp?.success && resp?.data) {
        const d = resp.data;
        setData(prev => ({
          ...prev,
          [tab]: pg === 1 ? (d[tab] || []) : [...(prev[tab] || []), ...(d[tab] || [])]
        }));
        setTotalCounts({
          streams: d.total_streams || 0,
          products: d.total_products || 0,
          sellers: d.total_sellers || 0
        });
        if (d.attribute_facets) {
          setAttributeFacets(d.attribute_facets);
        }
      }
    } catch (err) {
      console.error("Search error:", err);
    } finally {
      setLoading(false);
    }
  }, [debouncedQuery, activeTab, selectedCategory, selectedSubCategory, selectedPreSubCategory, selectedAttributes, nearbyLocation]);

  useEffect(() => {
    setPage(1);
  }, [debouncedQuery, activeTab, selectedCategory, selectedSubCategory, selectedPreSubCategory, selectedAttributes, nearbyLocation]);

  useEffect(() => {
    fetchData(activeTab, page);
  }, [page, fetchData, activeTab]);

  useEffect(() => {
    setSelectedSubCategory("");
    setSelectedPreSubCategory("");
    setSelectedAttributes({});
    fetchSubCategories(selectedCategory);
    fetchAttributes(selectedCategory);
  }, [selectedCategory]);

  useEffect(() => {
    setSelectedPreSubCategory("");
    fetchPreSubCategories(selectedSubCategory);
    // If we have a category but no subcategory selected yet, keep category attributes
    if (!selectedSubCategory && selectedCategory) {
      fetchAttributes(selectedCategory);
    }
  }, [selectedSubCategory]);

  useEffect(() => {
    if (selectedPreSubCategory) {
      fetchAttributes(selectedCategory, selectedPreSubCategory);
    } else if (selectedCategory) {
      // Fallback to category attributes if pre-sub is deselected
      fetchAttributes(selectedCategory);
    }
  }, [selectedPreSubCategory]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedQuery(searchInput.trim());
    }, 500);
    return () => clearTimeout(timer);
  }, [searchInput]);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setPage(1);
  };

  const handleViewStream = (item) => {
    const sellerId = item?.seller?._id || item?.seller_id || (typeof item?.seller === "string" ? item?.seller : "");
    const targetUrl = `/user/live-streams/${sellerId}/${item?.room_id}/${item?._id}`;
    if (!isUserLoggedIn()) {
      showLoginRequiredModal({
        navigate,
        redirectUrl: targetUrl,
        text: t("common.login_required_to_view_stream", { defaultValue: "Please login to view stream details" }),
      });
      return;
    }
    navigate(targetUrl);
  };

  const currentList = data[activeTab] || [];
  const totalCount = totalCounts[activeTab] || 0;
  const totalPages = Math.ceil(totalCount / PER_PAGE);

  const lastElementRef = useCallback(node => {
    if (loading) return;
    if (observer.current) observer.current.disconnect();
    observer.current = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting && page < totalPages) {
        setPage(prev => prev + 1);
      }
    });
    if (node) observer.current.observe(node);
  }, [loading, page, totalPages]);



  const handleNearByClick = () => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setNearbyLocation({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          });
          Swal.fire({
            icon: "success",
            title: t("search.nearby_enabled", "Location Enabled"),
            text: t("search.showing_nearby", "Showing items near your current location."),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          });
        },
        (error) => {
          if (error.code === error.PERMISSION_DENIED) {
            Swal.fire({
              icon: "warning",
              title: t("search.location_denied_title", "Location Access Denied"),
              text: t("search.location_denied_text", "Please enable location access in your browser settings (click the lock icon in the address bar) to find nearby items."),
              confirmButtonText: "Got it",
              confirmButtonColor: "var(--secondary-500)",
            });
          } else {
            Swal.fire({
              icon: "error",
              text: t("search.location_error", "Unable to retrieve your location. Please try again."),
            });
          }
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0,
        }
      );
    } else {
      Swal.fire({
        icon: "error",
        text: t("search.location_unsupported", "Geolocation is not supported by your browser."),
      });
    }
  };

  const handleClearNearby = () => {
    setNearbyLocation(null);
    Swal.fire({
      icon: "info",
      text: t("search.nearby_cleared", "Nearby filter cleared. Showing all items."),
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 2000,
    });
  };

  return (
    <div className="search-content-bg min-h-screen flex flex-col">
      {String(globalData?.product_tab_visibility) === "false" && activeTab === "products" ? (
        <div className="flex-grow flex items-center justify-center p-4">
          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-12 md:p-20 text-center w-full max-w-4xl mx-auto my-10">
            <h2 className="heading-web-h2 text-[var(--black-scale-900)] mb-4">{t("search.coming_soon_products", "Coming Soon")}</h2>
            <p className="text-zinc-500 text-lg">{t("search.coming_soon_products_desc", "Products will be available here soon. Stay tuned!")}</p>
          </div>
        </div>
      ) : String(globalData?.stream_tab_visibility) === "false" && activeTab === "streams" ? (
        <div className="flex-grow flex items-center justify-center p-4">
          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-12 md:p-20 text-center w-full max-w-4xl mx-auto my-10">
            <h2 className="heading-web-h2 text-[var(--black-scale-900)] mb-4">{t("search.coming_soon_streams", "Coming Soon")}</h2>
            <p className="text-zinc-500 text-lg">{t("search.coming_soon_streams_desc", "Live streams will be available here soon. Stay tuned!")}</p>
          </div>
        </div>
      ) : (
        <>
          <InnerTitle
            title={t("search.title")}
            value={searchInput}
            onChange={(e) => setSearchInput(e.target.value)}
            onNearByClick={handleNearByClick}
            isNearbyActive={Boolean(nearbyLocation)}
            onClearNearby={handleClearNearby}
          />

          <div className="container mt-12">
            {/* Tabs Navigation */}
            <div className="flex gap-2 mb-8 border-b border-gray-200 justify-center flex items-center overflow-x-auto no-scrollbar">
              {TABS.map((tab) => (
                <button
                  key={tab.key}
                  onClick={() => handleTabChange(tab.key)}
                  className={`px-6 py-3 text-base font-semibold whitespace-nowrap border-b-2 transition-all duration-300 ${activeTab === tab.key
                    ? "border-[var(--secondary-500)] text-[var(--secondary-500)]"
                    : "border-transparent text-gray-500 hover:text-gray-700"
                    }`}
                >
                  {t(tab.label)}
                </button>
              ))}
            </div>

            {/* Categories/Subcategories Filters - Products, Streams, Advertisers */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 items-center justify-center gap-3 mb-10 animate-fadeIn">
                <CategorySelectDropdown
                  value={selectedCategory}
                  onChange={(val) => setSelectedCategory(val)}
                  options={categories}
                  placeholder={t("search.all_categories")}
                  fallbackIcon="/category.png"
                />

                <CategorySelectDropdown
                  value={selectedSubCategory}
                  onChange={(val) => setSelectedSubCategory(val)}
                  options={subCategories}
                  placeholder={t("search.all_subcategories")}
                  disabled={!selectedCategory}
                  fallbackIcon="/category.png"
                />

                <CategorySelectDropdown
                  value={selectedPreSubCategory}
                  onChange={(val) => setSelectedPreSubCategory(val)}
                  options={preSubCategories}
                  placeholder={t("search.all_presubcategories")}
                  disabled={!selectedSubCategory}
                  fallbackIcon="/category.png"
                />

                {/* Color Palette Popover Dropdown */}
                <div className="relative">
                  <button
                    type="button"
                    onClick={() => setIsColorPaletteBoxOpen(!isColorPaletteBoxOpen)}
                    className="appearance-none w-full pl-4 pr-10 py-2.5 rounded-xl border border-gray-200 bg-white shadow-sm text-sm font-semibold text-gray-700 cursor-pointer focus:outline-none focus:ring-2 focus:ring-[var(--secondary-500)] text-left flex items-center justify-between hover:border-[var(--secondary-500)] hover:shadow-md transition-all"
                  >
                    <span className="truncate">
                      {activeSelectedColors.length > 0
                        ? `${t("search.filter_by_color")} (${activeSelectedColors.length})`
                        : t("search.filter_by_color")}
                    </span>
                    <div className="absolute right-4 inset-y-0 flex items-center pointer-events-none text-gray-400">
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                      </svg>
                    </div>
                  </button>

                  {isColorPaletteBoxOpen && (
                    <>
                      <div className="fixed inset-0 z-30" onClick={() => setIsColorPaletteBoxOpen(false)} />
                      <div
                        className="absolute left-auto right-0 -translate-x-0 top-full mt-2.5 z-40 w-full max-w-[350px] bg-white rounded-2xl shadow-[0_10px_35px_rgba(0,0,0,0.15)] border border-gray-100 p-4 animate-zoomIn origin-top"
                      >
                        {selectedPaletteIdForColors ? (
                          // Sub-colors selection view
                          (() => {
                            const selectedPalette = colorPalettes.find(p => p._id === selectedPaletteIdForColors);
                            if (!selectedPalette) return null;
                            const palateName = selectedPalette.name;
                            const tabColors = selectedPalette.colors || [];

                            return (
                              <div className="flex flex-col">
                                <div className="flex items-center justify-between border-b border-gray-100 pb-2 mb-3">
                                  <button
                                    type="button"
                                    onClick={() => setSelectedPaletteIdForColors(null)}
                                    className="flex items-center gap-1 text-xs font-bold text-[var(--secondary-500)] hover:underline"
                                  >
                                    ← Back
                                  </button>
                                  <span className="text-xs font-extrabold text-gray-800 uppercase tracking-wide">
                                    {palateName} Colors
                                  </span>
                                  <div className="flex gap-2">
                                    <button
                                      type="button"
                                      onClick={() => toggleAllColorsInTab(tabColors, true)}
                                      className="text-[10px] font-bold text-[var(--secondary-500)] hover:underline"
                                    >
                                      All
                                    </button>
                                    <button
                                      type="button"
                                      onClick={() => toggleAllColorsInTab(tabColors, false)}
                                      className="text-[10px] font-bold text-gray-400 hover:underline"
                                    >
                                      None
                                    </button>
                                  </div>
                                </div>

                                <div className="max-h-60 overflow-y-auto space-y-1.5 custom-scrollbar pr-0.5">
                                  {tabColors.map(color => {
                                    const isSelected = activeSelectedColors.includes(color.name);
                                    let swatchBg = color.hex;
                                    if (color.name === "Transparent") {
                                      swatchBg = 'repeating-linear-gradient(45deg, #e0e0e0, #e0e0e0 4px, #ffffff 4px, #ffffff 8px)';
                                    } else if (color.name === "Multicolour") {
                                      swatchBg = 'linear-gradient(135deg, #ff0000, #ff7f00, #ffff00, #00ff00, #0000ff, #4b0082, #8f00ff)';
                                    } else if (color.gradient) {
                                      swatchBg = color.gradient;
                                    }

                                    return (
                                      <button
                                        key={color.name}
                                        type="button"
                                        onClick={() => toggleSubColor(color.name)}
                                        className={`w-full flex items-center justify-between p-1.5 rounded-lg border text-left transition-all ${isSelected
                                          ? "border-[var(--secondary-300)] bg-[var(--secondary-50)]/30 font-semibold"
                                          : "border-transparent hover:bg-gray-50"
                                          }`}
                                      >
                                        <div className="flex items-center gap-2">
                                          <div
                                            style={{
                                              width: "16px",
                                              height: "16px",
                                              borderRadius: "50%",
                                              background: swatchBg,
                                              border: "1px solid rgba(0,0,0,0.15)"
                                            }}
                                          />
                                          <span className="text-[11px] text-gray-700">{color.name}</span>
                                        </div>
                                        <input
                                          type="checkbox"
                                          checked={isSelected}
                                          readOnly
                                          className="w-3.5 h-3.5 accent-[var(--secondary-500)] cursor-pointer"
                                        />
                                      </button>
                                    );
                                  })}
                                </div>
                              </div>
                            );
                          })()
                        ) : (
                          // Palettes grid view (Image 1 style)
                          <div className="flex flex-col">
                            <div className="flex items-center justify-between border-b border-gray-100 pb-2 mb-3">
                              <span className="text-[11px] font-extrabold text-gray-500 uppercase tracking-wider">
                                Color Palettes
                              </span>
                              {activeSelectedColors.length > 0 && (
                                <button
                                  onClick={clearColorFilter}
                                  className="text-[10px] font-bold text-red-500 hover:text-red-600 bg-red-50 px-2 py-0.5 rounded transition-all"
                                >
                                  Reset
                                </button>
                              )}
                            </div>

                            <div className="grid grid-cols-3 gap-y-4 gap-x-2 max-h-80 overflow-y-auto custom-scrollbar p-1">
                              {colorPalettes.map(palette => {
                                const palateName = palette.name;
                                const tabColors = palette.colors || [];
                                const tabColorNames = tabColors.map(c => c.name);
                                const selectedInTab = activeSelectedColors.filter(c => tabColorNames.includes(c));
                                const isAnySelected = selectedInTab.length > 0;
                                const bgStyle = getPalateBackground(tabColors, palateName);

                                return (
                                  <button
                                    key={palette._id}
                                    type="button"
                                    onClick={() => {
                                      setSelectedPaletteIdForColors(palette._id);
                                      toggleAllColorsInTab(tabColors, true);
                                    }}
                                    className="flex flex-col items-center group/palette focus:outline-none"
                                  >
                                    <div
                                      className="relative rounded-full transition-all duration-200"
                                      style={{
                                        width: "50px",
                                        height: "50px",
                                        background: bgStyle,
                                        border: isAnySelected
                                          ? "3.5px solid var(--secondary-500)"
                                          : "2px solid #e2e8f0",
                                        boxShadow: isAnySelected
                                          ? "0 0 10px rgba(255, 99, 181, 0.7)"
                                          : "none",
                                        transform: "scale(1)"
                                      }}
                                    >
                                      {selectedInTab.length > 0 && (
                                        <div className="absolute -top-1.5 -right-1.5 bg-[var(--secondary-500)] text-white text-[9px] font-bold w-4.5 h-4.5 rounded-full flex items-center justify-center border border-white">
                                          {selectedInTab.length}
                                        </div>
                                      )}
                                    </div>
                                    <span className="text-[10px] text-gray-600 font-bold mt-1 text-center leading-snug w-full truncate group-hover/palette:text-[var(--secondary-500)]">
                                      {palateName}
                                    </span>
                                  </button>
                                );
                              })}
                            </div>
                          </div>
                        )}
                      </div>
                    </>
                  )}
                </div>
              </div>

            {/* Filter Content & Results Header */}
            <div className="flex flex-col md:flex-row items-center justify-between gap-4 mb-8">
              <div className="flex items-center gap-3">
                <h2 className="text-xl font-bold text-gray-800">
                  {activeTab === "streams" ? t("search.stream_results") : activeTab === "products" ? t("search.product_results") : t("search.seller_results")}
                </h2>
                {/* <span className="bg-gray-100 text-gray-600 px-3 py-0.5 rounded-full text-sm font-medium">
                {activeTab === "products" ? totalCounts.products : totalCounts.sellers}
              </span> */}
              </div>

              {(selectedPreSubCategory || (selectedCategory && searchAttributes.length > 0)) && (
                <div className="relative">
                  <button
                    onClick={() => setIsFilterOpen(!isFilterOpen)}
                    className={`flex items-center gap-2 px-5 py-2.5 rounded-xl text-sm font-bold transition-all shadow-sm active:scale-95 ${isFilterOpen || Object.keys(selectedAttributes).length > 0
                      ? "bg-[var(--secondary-500)] text-white shadow-[var(--secondary-200)]"
                      : "bg-white text-gray-700 border border-gray-200 hover:border-[var(--secondary-300)]"
                      }`}
                  >
                    <SlidersHorizontal className="w-4 h-4" />
                    {t("search.filters")}
                    <span className="ml-1 bg-white text-[var(--secondary-500)] w-5 h-5 rounded-full flex items-center justify-center text-[10px]">
                      {getSelectedFiltersCount()}
                    </span>
                  </button>

                  {/* Redesigned Dropdown Filter Box (Chip Style - Compact) */}
                  {isFilterOpen && (
                    <>
                      <div className="fixed inset-0 z-10" onClick={() => setIsFilterOpen(false)} />

                      <div className="absolute right-0 top-full mt-2 z-20 w-[440px] bg-white rounded-2xl shadow-[0_10px_40px_rgba(0,0,0,0.12)] border border-gray-100 flex flex-col overflow-hidden animate-zoomIn origin-top-right">
                        {/* Header */}
                        <div className="px-5 pt-4 pb-3 border-b border-gray-100">
                          <div className="flex items-center justify-between">
                            <div className="flex items-center gap-2">
                              <div className="w-7 h-7 bg-[var(--secondary-500)] rounded-lg flex items-center justify-center">
                                <SlidersHorizontal className="w-3.5 h-3.5 text-white" />
                              </div>
                              <div>
                                <h3 className="text-[13px] font-extrabold text-gray-900 leading-tight">Filter Attributes</h3>
                                {Object.keys(selectedAttributes).length > 0 && (
                                  <p className="text-[10px] text-[var(--secondary-500)] font-semibold">
                                    {getSelectedFiltersCount()} selected
                                  </p>
                                )}
                              </div>
                            </div>
                            <button
                              onClick={() => {
                                setSelectedAttributes({});
                                setPage(1);
                                fetchData(activeTab, 1);
                              }}
                              className="flex items-center gap-1 text-[10px] font-bold text-red-400 hover:text-red-500 hover:bg-red-50 px-2 py-1 rounded-lg transition-all"
                            >
                              <Trash2 className="w-3 h-3" />
                              Reset
                            </button>
                          </div>
                          <div className="h-[1px] bg-gray-50 w-full" />
                          <div className="px-5 py-2">
                            <input
                              type="text"
                              placeholder="Search attributes..."
                              value={attributeSearch}
                              onChange={(e) => setAttributeSearch(e.target.value)}
                              className="w-full px-3 py-1.5 text-sm border border-gray-200 rounded-lg focus:outline-none focus:border-[var(--secondary-500)]"
                            />
                          </div>
                        </div>

                        {/* Body */}
                        <div className="max-h-[300px] overflow-y-auto px-5 py-2 pb-5 space-y-4 custom-scrollbar bg-white">
                          {searchAttributes.length > 0 ? (
                            <div className="space-y-4">
                              {searchAttributes.map((attr) => {
                                const attrName = attr.name;
                                const facetValues = attributeFacets[attrName] || [];
                                const colorMap = {};
                                const expandedValues = expandTabValues(attr.values || []);
                                const expandedFacetValues = expandTabValues(facetValues || []);

                                const attrValuesNames = expandedValues.map(val => {
                                  if (val && typeof val === 'object') {
                                    if (val.name && typeof val.name === 'object' && val.name.name) {
                                      const colorName = val.name.name;
                                      const colorCode = val.name.colorCode || null;
                                      if (colorName) {
                                        colorMap[colorName] = colorCode;
                                        return colorName;
                                      }
                                    }
                                    if (val.name && typeof val.name === 'string') {
                                      const colorName = val.name;
                                      const colorCode = val.colorCode || null;
                                      colorMap[colorName] = colorCode;
                                      return colorName;
                                    }
                                  }
                                  return String(val || '');
                                }).filter(v => v.trim() !== '');

                                const sanitizedFacetValues = expandedFacetValues.map(val => {
                                  if (val && typeof val === 'object') {
                                    if (val.name && typeof val.name === 'object' && val.name.name) {
                                      const colorName = val.name.name;
                                      const colorCode = val.name.colorCode || null;
                                      if (colorName) {
                                        colorMap[colorName] = colorCode;
                                        return colorName;
                                      }
                                    }
                                    if (val.name && typeof val.name === 'string') {
                                      const colorName = val.name;
                                      const colorCode = val.colorCode || null;
                                      colorMap[colorName] = colorCode;
                                      return colorName;
                                    }
                                  }
                                  return String(val || '');
                                }).filter(v => v.trim() !== '');

                                const allValues = [...new Set([...attrValuesNames, ...sanitizedFacetValues])];

                                const isColor = attrName.toLowerCase().includes('color') || attrName.toLowerCase().includes('colour') || attrName.toLowerCase().includes('palate') || attrName.toLowerCase().includes('palette') || attr.hasColorCode;

                                if (isColor) return null;

                                // Filter based on search
                                if (attributeSearch && !attrName.toLowerCase().includes(attributeSearch.toLowerCase())) return null;

                                if (attr.attributeType === 'user_input' && !attr.isVisibleInFilter) return null;

                                const filteredValues = allValues
                                  .map(v => {
                                    if (v === null || v === undefined) return '';
                                    if (typeof v === 'object') return v.name || '';
                                    return String(v);
                                  })
                                  .filter(v => v.trim() !== '');

                                if (filteredValues.length === 0) return null;
                                const getAttrSelectedCount = () => {
                                  const selectedValues = selectedAttributes[attrName] || [];
                                  if (selectedValues.length === 0) return 0;
                                  if (isColor) {
                                    let count = 0;
                                    PALETTE_COLUMNS.forEach(col => {
                                      const tabColorNames = col.colors.map(c => c.name);
                                      const hasSelectedColor = selectedValues.some(val => tabColorNames.includes(val));
                                      if (hasSelectedColor) {
                                        count++;
                                      }
                                    });
                                    const allTabColorNames = PALETTE_COLUMNS.reduce((acc, col) => acc.concat(col.colors.map(c => c.name)), []);
                                    const unmatchedCount = selectedValues.filter(val => !allTabColorNames.includes(val)).length;
                                    return count + unmatchedCount;
                                  }
                                  return selectedValues.length;
                                };
                                const selectedCount = getAttrSelectedCount();

                                return (
                                  <div key={attr._id}>
                                    {/* Attribute Label Row */}
                                    <div className="flex items-center justify-between mb-2">
                                      <span className="text-[11px] font-extrabold text-gray-800 uppercase tracking-wide">
                                        {capitalizeFirstLetter(attrName)}
                                      </span>
                                      {selectedCount > 0 && (
                                        <span className="text-[9px] font-bold bg-[var(--secondary-500)] text-white px-1.5 py-0.5 rounded-full">
                                          {selectedCount}
                                        </span>
                                      )}
                                    </div>

                                    {isColor ? (
                                      <div className="space-y-2.5 w-full">
                                        {(() => {
                                          const groups = {};
                                          filteredValues.forEach(v => {
                                            const colorCode = colorMap[v] || (v.toLowerCase() === 'nude' ? '#E3BC9A' : v.toLowerCase() === 'transparent' ? 'transparent' : v.toLowerCase().replace(/ /g, ''));
                                            const palateName = getColorPalateName(v, colorCode);
                                            if (!groups[palateName]) groups[palateName] = [];
                                            groups[palateName].push({ name: v, colorCode });
                                          });

                                          return (
                                            <div className="space-y-3">
                                              {/* Grid of Palette Circles */}
                                              <div className="grid grid-cols-6 gap-2.5">
                                                {PALETTE_COLUMNS.map(col => col.name).map(palateName => {
                                                  const tabColors = getTabColors(palateName);
                                                  const tabColorNames = tabColors.map(c => c.name);

                                                  // Check how many of this tab's colors are currently selected
                                                  const selectedInTab = (selectedAttributes[attrName] || []).filter(v => tabColorNames.includes(v));
                                                  const selectedCount = selectedInTab.length;
                                                  const isAllSelected = tabColorNames.length > 0 && tabColorNames.every(c => (selectedAttributes[attrName] || []).includes(c));

                                                  const bgStyle = getPalateBackground(tabColors, palateName);

                                                  return (
                                                    <div key={palateName} className="relative flex flex-col items-center">
                                                      <button
                                                        type="button"
                                                        onClick={() => {
                                                          setSelectedAttributes(prev => {
                                                            const currentValues = prev[attrName] || [];
                                                            let next;
                                                            if (isAllSelected) {
                                                              // Deselect all colors of this tab
                                                              next = currentValues.filter(val => !tabColorNames.includes(val));
                                                            } else {
                                                              // Select all colors of this tab
                                                              next = [...new Set([...currentValues, ...tabColorNames])];
                                                            }

                                                            const newState = { ...prev };
                                                            if (next.length === 0) {
                                                              delete newState[attrName];
                                                            } else {
                                                              newState[attrName] = next;
                                                            }
                                                            return newState;
                                                          });
                                                        }}
                                                        onMouseEnter={() => setHoveredPalate(palateName)}
                                                        onMouseLeave={() => setHoveredPalate(null)}
                                                        style={{
                                                          width: "38px",
                                                          height: "38px",
                                                          borderRadius: "50%",
                                                          background: bgStyle,
                                                          border: selectedCount > 0
                                                            ? "3px solid var(--secondary-500)"
                                                            : "1.5px solid #e2e8f0",
                                                          cursor: "pointer",
                                                          transform: hoveredPalate === palateName ? "scale(1.15)" : "none",
                                                          transition: "all 0.2s ease",
                                                          boxShadow: selectedCount > 0
                                                            ? "0 0 8px rgba(255, 99, 181, 0.6)"
                                                            : "none"
                                                        }}
                                                        title={`${palateName} Palette`}
                                                      />
                                                      <span className="text-[8px] text-gray-500 font-bold mt-1 text-center max-w-[50px] overflow-hidden text-ellipsis whitespace-nowrap">
                                                        {palateName}
                                                      </span>
                                                    </div>
                                                  );
                                                })}
                                              </div>
                                            </div>
                                          );
                                        })()}
                                      </div>
                                    ) : (
                                      <div className="flex flex-wrap gap-1.5">
                                        {filteredValues.map((v, i) => {
                                          const isSelected = (selectedAttributes[attrName] || []).includes(v);
                                          return (
                                            <button
                                              key={i}
                                              onClick={() => {
                                                setSelectedAttributes(prev => {
                                                  const currentValues = prev[attrName] || [];
                                                  if (currentValues.includes(v)) {
                                                    const next = currentValues.filter(val => val !== v);
                                                    const newState = { ...prev };
                                                    if (next.length === 0) {
                                                      delete newState[attrName];
                                                    } else {
                                                      newState[attrName] = next;
                                                    }
                                                    return newState;
                                                  }
                                                  return { ...prev, [attrName]: [...currentValues, v] };
                                                });
                                              }}
                                              className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full border text-[10px] font-bold transition-all ${isSelected
                                                ? "bg-[#FFEDED] border-[#FF8E8E] text-[#FF8E8E]"
                                                : "bg-white border-[#F2F2F2] text-[#111] hover:border-gray-300"
                                                }`}
                                            >
                                              {v}
                                            </button>
                                          );
                                        })}
                                      </div>
                                    )}
                                  </div>
                                );
                              })}
                            </div>
                          ) : (
                            <div className="flex flex-col items-center justify-center py-8 gap-2">
                              <div className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center">
                                <SlidersHorizontal className="w-5 h-5 text-gray-400" />
                              </div>
                              <p className="text-gray-400 text-xs font-medium">No filters available</p>
                              <p className="text-gray-300 text-[10px]">Select a category to see filters</p>
                            </div>
                          )}
                        </div>

                        {/* Footer */}
                        <div className="px-5 pt-3 pb-4 border-t border-gray-100 bg-gray-50/50">
                          <div className="flex gap-2">
                            {/* <button
                            onClick={() => {
                              setSelectedAttributes({});
                              setPage(1);
                              fetchData(activeTab, 1);
                            }}
                            className="flex-1 py-2.5 rounded-xl border border-gray-200 bg-white text-[12px] font-bold text-gray-600 hover:bg-gray-100 transition-all active:scale-95"
                          >
                            Clear
                          </button> */}
                            <button
                              onClick={() => {
                                setIsFilterOpen(false);
                                setPage(1);
                                fetchData(activeTab, 1);
                              }}
                              className="flex-[2] py-2.5 rounded-xl bg-[var(--secondary-500)] text-white text-[12px] font-bold hover:brightness-105 active:scale-95 transition-all shadow-sm"
                            >
                              Apply Filters
                            </button>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              )}
            </div>




            {/* Content Section */}

            <div className="w-full">

              {loading && page === 1 ? (
                <div className="flex items-center justify-center py-24">
                  <div className="w-16 h-16 border-4 border-[#FF63B5] border-t-transparent rounded-full animate-spin"></div>
                </div>
              ) : currentList.length === 0 ? (
                <div className="text-center w-full py-20 bg-gray-50 rounded-2xl border border-dashed border-gray-300 my-10 mx-4">
                  {/* <img src="/images/no-data.svg" alt="No data" className="mx-auto w-24 mb-4 opacity-50" /> */}
                  <p className="text-gray-500 font-medium">
                    {t("search.no_data_found", { type: t(`search.tabs.${activeTab}`) })}
                  </p>
                </div>
              ) : (
                <>

                  <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-[20px] lg:gap-[25px] pb-10">
                    {activeTab === "streams" && currentList.map((item, index) => (
                      <div
                        key={index}
                        ref={index === currentList.length - 1 ? lastElementRef : null}
                        className="flex flex-col"
                      >
                        <Card
                          images={item.thumbnail}
                          title={item.title}
                          subtitle={item.description}
                          time={item.duration}
                          live={item.isLive}
                          distance={item.distance}
                          onClick={() => handleViewStream(item)}
                          isLiked={item.isFavouriteStream}
                          onLikeClick={(e) => {
                            e.stopPropagation();
                            handleLikeFavourite(item);
                          }}
                        />
                      </div>
                    ))}

                    {activeTab === "products" && currentList.map((item, index) => {
                      const matchedImage = getMatchingProductImage(item, activeSelectedColors);
                      const displayImage = matchedImage
                        ? (matchedImage.compressed || matchedImage.url)
                        : item.image;
                      const displayCompressed = matchedImage
                        ? (matchedImage.compressed || matchedImage.compressed_url)
                        : item.compressed_image;
                      const displayOriginal = matchedImage
                        ? matchedImage.url
                        : (item.originalImage || item.image);
                      const targetColor = matchedImage
                        ? (typeof matchedImage.color === "string" ? matchedImage.color : matchedImage.color?.name)
                        : null;

                      return (
                        <div
                          key={item._id || index}
                          ref={index === currentList.length - 1 ? lastElementRef : null}
                          className="flex flex-col cursor-pointer"
                          onClick={() => {
                            const query = targetColor
                              ? `?o_id=${item?._id}&color=${encodeURIComponent(targetColor)}`
                              : `?o_id=${item?._id}`;
                            const targetUrl = `/user/product-details${query}`;
                            if (!isUserLoggedIn()) {
                              showLoginRequiredModal({
                                navigate,
                                redirectUrl: targetUrl,
                              });
                              return;
                            }
                            navigate(targetUrl);
                          }}
                        >
                          <Card
                            images={displayImage}
                            compressedImage={displayCompressed}
                            originalImage={displayOriginal}
                            title={item.title}
                            subtitle={item.description}
                            price={item.price}
                            isAskForPrice={item.isAskForPrice}
                            time={null}
                            live={false}
                            distance={item.distance}
                            isLiked={Boolean(item.isFavourite || item.isFavouriteProduct)}
                            onLikeClick={(e) => {
                              e.stopPropagation();
                              handleLikeFavouriteProduct(item);
                            }}
                          />
                        </div>
                      );
                    })}

                    {activeTab === "sellers" && currentList.map((item, index) => (
                      <div
                        key={item._id || index}
                        ref={index === currentList.length - 1 ? lastElementRef : null}
                        className="flex flex-col cursor-pointer"
                        onClick={() => navigate(getSellerProfileUrl(item))}
                      >
                        <SellerCard
                          images={item.profile_image}
                          title={item.store_name || item.name}
                          subtitle={item.business_handle ? (item.business_handle.startsWith("@") ? item.business_handle : `@${item.business_handle}`) : null}
                          distance={item.distance}
                        />
                      </div>
                    ))}
                  </div>
                  {loading && page > 1 && (
                    <div className="flex justify-center items-center py-8">
                      <div className="w-10 h-10 border-4 border-[#FF63B5] border-t-transparent rounded-full animate-spin"></div>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </>
      )}
      {modalProduct && (
        <ShoplistSelectModal
          isOpen={isShoplistModalOpen}
          product={modalProduct}
          onClose={() => {
            setIsShoplistModalOpen(false);
            setModalProduct(null);
          }}
          onSaved={handleShoplistSaved}
        />
      )}
    </div>
  );
}

export default Search;
